import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { css } from "styled-components";
import { fontVariables } from "@hzero-front-ui/font";
export var getSelectArrow = function getSelectArrow() {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  content: \"\\E5CF\";\n  font-family: ", ", sans-serif !important;\n  font-size: 0.16rem;\n"], ["\n  content: \"\\\\E5CF\";\n  font-family: ", ", sans-serif !important;\n  font-size: 0.16rem;\n"])), fontVariables.defaultIconfontFamily);
};